import { IEntity, IFacetsSearchResponse } from './IEntity';
import { IAddress } from './IProfile';
import { IReferentialTranslation } from './ILabelTranslation';
import { ELcid } from './ILanguage';
import { IRole } from './IRoles';
import { ERoleType } from './IPermissions';
import { IPrincipalDisplay } from './IPrincipalColumn';
export interface ISingleCompany {
    StatusCollaboration: string;
    IsVisible: string;
    IsValidated: boolean;
    DateBegin: string;
    DateEnd: string;
    FunctionTitle: string;
    Address: IAddress;
    AssociatedCustomer: {
        ContactLastName: string;
        ContactFirstname: string;
        ContactJobTitle: string;
        Email: string;
        Department: string;
        Contacts: {
            ContactLastName: string;
            ContactFirstname: string;
            ContactJobTitle: string;
            Email: string;
            Department: string;
        }[];
        Scale: string;
        UserType: number;
        FirmId: number;
        tenantId: string;
        DigitalWorkplaceUrl: string;
        IndexName: string;
        IsIndexVisible: boolean;
        Version: string;
        id: string;
        Name: string;
        LogicalId: number;
        DataType: string;
        UpdatedBy: string;
        LastModification: string;
    };
    Typology: {
        Name: string;
        id: string;
    };
    Size: IEntity;
    WebsiteUrl: string;
    Picture: string;
    Version: string;
    Presentation: string;
    IsPublic: boolean;
    IsCurrent: boolean;
    AdminList: {
        id: string;
        FirstName: string;
        LastName: string;
    }[];
    NumberOfUsers: number;
    id: string;
    Name: string;
    LogicalId: number;
    DataType: string;
    UpdatedBy: string;
    LastModification: string;
}

export enum EReferentialTypes {
    FirstReferential = 'FirstReferential',
    SecondReferential = 'SecondReferential',
    ThirdReferential = 'ThirdReferential',
    Department = 'Department'
}

export interface IReferentialIdentitie {
    id: string;
    name: string;
    referentialType: string;
    key: string;
    context?: string;
}

export interface ISingleContext {
    context: string;
    items: IReferentialIdentitie[];
}

export interface IReferentialContexts {
    contexts: ISingleContext[];
}

export interface IListOfReferetnialTypes {
    Items: [{
        id: string;
        Name: string;
    }];
    Size: number;
    Page: number;
    Count: number;
}

export enum EReferentialType {
    Thematic = 'Thematic',
    Information = 'Information',
    Administration = 'Administration',
    SubThematic = 'Sub-thematic',
    IndividualThematic = 'Individual Thematic',
    Items = 'Items',
    AreaOfResponsibility = 'Area of responsibility'
}

export interface INormReferential {
    context: string;
    isVisible: boolean;
    name: string;
    owner?: string;
    referentialType: EReferentialType;
    id: string;
}

export interface INormReferentialItemsResult {
    Count: number;
    Items: INormReferentialItem[];
    Page: number;
    Size: number;
}
export interface INormReferentialItem {
    key?: string;
    name: IReferentialTranslation[];
    id: string;
    parents: string[];
}

export interface IFullReferentialElement {
    name: IReferentialTranslation[];
    id: string;
    key: string;
}

export interface ISingleGroup {
    id?: string;
    name: string;
    description: string;
    groupUsers: ISingleGroupUser[];
    isEditable?: boolean;
    isHidden?: boolean;
    principalsCount?: number;
    createdAt?: string;
}

export interface IGetPeopleAndGroupsPersona {
    text: string;
    imageInitials: string;
    imageUrl: string;
    secondaryText: string;
    id: string;
    originalResult: {
        id: string,
        name: string,
        picture: string,
        type: 'Group' | 'Personal',
        emailWithoutAtSign: string
    }
}

export enum ESingleGroupTabs {
    Members = 'Members',
    ClusterLink = 'ClusterLink'
}

export interface ISingleGroupUser  {
    cabinet?: string;
    name?: string;
    id?: string;
    jobTitle?: string;
    picture?: string;
    role?: IRole;
    type?: string;
    text?: string;
}

export interface INameTranslation {
    label: string;
    lcid: ELcid;
}

export interface IUsefulLink {
    name: INameTranslation[];
    picture: string;
    url: string;
    id: string;
}

export interface IUsefulLinkMember {
    id: string;
    type: string;
    name: string;
    picture: string;
}

export interface IManageUsefulLinkItem {
    order: number;
    visibility: string;
    members: IUsefulLinkMember[];
    id: string;
    name: INameTranslation[];
    picture: string;
    url: string;
}

export interface ICreateUsefulLink {
    name: INameTranslation[];
    visibility: string;
    members?: IUsefulLinkMember[];
    url: string;
    picture?: string;
}

export interface ICreateWorkspaceInvitationPayload {
    legalEntityIds?: string[] | null;
    organizationIds?: string[] | null;
    roleInOrganization: string;
    sendNotification: boolean;
    expression?: string;
}

export interface IUpdateWorkspaceInvitationPayload {
    allEntities: boolean;
    legalEntityId?: string | null;
    organizationId: string;
    roleInOrganization: string;
    sendNotification: boolean;
    ruleName: string;
    expression?: string;
}

export type IGroupsAndPeople = IFacetsSearchResponse<IGroupsAndPeopleItems, {
    type: {
        Key: string;
        id: string;
        name: string;
    }[];
}>;

export interface IGroupsAndPeopleItems {
    id: string;
    name: string;
    picture: string;
    type: 'Group' | 'Personal';
}
export interface IGroupsAndPeope {
    items: {
        id: string;
        name: string;
        picture: string;
        type: string;
    }[];
}

export interface ISearchMyLinks {
    items: IUsefulLink[];
    size: number;
    page: number;
    count: number;
    itemsOnPageCount: number;
}

export interface IListOfReferetnialTypesPayload {
    owner?: string;
    query?: string;
    page?: number;
    size?: number;
}

export interface IPeopleSearch {
    text: string;
    imageInitials: string;
    imageUrl: string;
    secondaryText: string;
    id: string;
    originalResult: IGetPeople;
}
export interface IGetPeople {
    cabinet: string;
    firstName: string;
    id: string;
    jobTitle: string;
    lastName: string;
    picture: string;
}

export interface ISingleGroupDataTableItem {
    'created-at': string;
    description: string;
    isEditable?: boolean;
    principal: IPrincipalDisplay;
    members: IPrincipalDisplay[];
}

export interface ISingleGroupMembersDataTableItem {
    'added-at': string;
    principal: IPrincipalDisplay;
    role: {
        childId: string;
        id: string;
        isHidden: boolean;
        name: string;
        resourceType: ERoleType;
    };
}